import React, { useEffect } from 'react';
import styled from 'styled-components';
import logo from '../assets/logo.png';

const Overlay = styled.div`
    position: fixed;
    inset: 0;
    z-index: 9999;
    background: #eaf4ff;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem;
`;

const Card = styled.div`
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.12);
    padding: 3rem 2rem;
    max-width: 520px;
    width: 100%;
    text-align: center;
`;

const LogoImage = styled.img`
    height: 70px;
    width: auto;
    margin-bottom: 1.5rem;
`;

const Title = styled.h1`
    font-size: 1.8rem;
    color: #333;
    margin: 0 0 0.75rem;
`;

const Message = styled.p`
    font-size: 1.05rem;
    color: #555;
    margin: 0 0 1.5rem;
`;

const Accent = styled.div`
    width: 60px;
    height: 4px;
    background: #f5a623;
    border-radius: 2px;
    margin: 0 auto 1.5rem;
`;

const ContactLine = styled.p`
    font-size: 0.95rem;
    color: #777;
    margin: 0;

    a {
        color: #2a7de1;
        font-weight: 600;
        text-decoration: none;

        &:hover {
            text-decoration: underline;
        }
    }
`;

const MaintenanceModal = () => {
    // Prevent the page behind the overlay from scrolling
    useEffect(() => {
        const previous = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = previous;
        };
    }, []);

    return (
        <Overlay role="dialog" aria-modal="true" aria-labelledby="maintenance-title">
            <Card>
                <LogoImage src={logo} alt="BeFriend ABA Services for Children" />
                <Accent />
                <Title id="maintenance-title">We&apos;ll be right back</Title>
                <Message>
                    Our website is temporarily down for maintenance. We&apos;re working to
                    bring it back online as soon as possible. Thank you for your patience.
                </Message>
                <ContactLine>
                    Need to reach us in the meantime?{' '}
                    <a href="mailto:info@befriendtherapy.com">info@befriendtherapy.com</a>
                </ContactLine>
            </Card>
        </Overlay>
    );
};

export default MaintenanceModal;
